import React from 'react';
import { Outlet } from 'react-router-dom';
import { FeatureFlagsConsumer } from '@lms/react-configuration/context/feature-flags';
import Loading from '../components/Loading';

const LayoutRoute = () => {
  return (
    <FeatureFlagsConsumer
      loading={<Loading />}
    >
      <Outlet />
    </FeatureFlagsConsumer>
  );
};

export default LayoutRoute;